import React from 'react';
import SectionIds from '../../Helper/SectionId';
import './Quote.css';
import Button from '../../Components/Button/Button';
import goToLink from '../../Helper/GoToLink';
import GoToLinks from '../../Data/GoToLinks';
import AssetImage from '../../Helper/AssetImage';
import AssetImages from '../../Helper/AssetImages';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';

export default function Quote() {
    return (
        <SectionWithAnalytics className='background-gradient section-block-margin' id={SectionIds.sectionQuote}>
            <div className='content'>
                <AssetImage assetImage={AssetImages.illustrationItermidiateTrader} className='bg-img' />
                <div className='header container-vertical res-gap-24 justify-content-right'>

                    <h3 className='clr-grey-100 text-align-right'>
                        We've got you all covered,<br /> Unlock the door to <mark>
                            <br /> Financial Freedom.
                        </mark>
                    </h3>

                    <Button name='Open Demat Account' onClick={() => goToLink(GoToLinks.accountOpening)} />
                </div>
            </div>
        </SectionWithAnalytics>
    )
}
